import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementPlus from 'element-plus'
  // import { ElDialog,ElCarousel,ElCarouselItem } from 'element-plus'

createApp(App).use(store).use(router).mount('#app')
